import { getServiceInstance } from "./base.service";
const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export const fetchAddressService = async (searchQuery: string) => {
    try {
        const response = await getServiceInstance().get(`${BASE_URL}/addresses?search=${encodeURIComponent(searchQuery)}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching address:", error);
        throw error;

    }
}